import './style.scss'
import { useContext, useEffect, useState } from "react";
import VisibilityContext from 'src/provider/state-manager/visibilityProvider';
import UserContext from 'src/provider/state-manager/userProvider';
import { AbsoluteContainer, AppSpan, AppText, Button, CustomContainer, FlexRow, Form, FormGroup, FormGroupWithIcon, GridContainer } from "src/style";
import { AppCenterPopupD3, CenterPopupHeaderD3, ComingSoon, GeneratedCodeViewD3, TxPinVerificationD3 } from "src/component";
import { FiChevronDown } from "react-icons/fi";
import WithdrawalIcon from 'src/assets/svg/cardless-withdrawal-phone-icon'
import ActiveLockIcon from 'src/assets/svg/cardless-withdrawal-lock-icon'
import {cardlessWithdrawalActiveCode} from 'src/utils/mock-data'
import utility, { moneyFormat } from 'src/utils/utility';
import AppInfoContext from 'src/provider/state-manager/appInfoProvider';

export const CardlessWithdrawalD3: React.FC<any> =({close}) => {
    const {user: { accountWithBalanceDetails}} = useContext(UserContext)
    const [navPosition, setNavPosition] = useState(0)
    const [input, setInput] = useState({sourceAccount: '', amount: ''})
    const [generatedCode, setGeneratedCode] = useState('')
    const [view, setView] = useState('generate-code')
    const {info:institutionData} = useContext(AppInfoContext)

    useEffect(() => {
        if (accountWithBalanceDetails?.length === 1) {
            setInput({...input, sourceAccount: accountWithBalanceDetails[0].nuban})
        }
    }, [accountWithBalanceDetails, input.sourceAccount])

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => {
        if (e.target.name === 'amount') {
            let val = e.target.value.replace(/[,.]/g, '')
            if (!isNaN(Number(val))) {
                setInput({...input, amount: val})
            }
        }
        else setInput({...input, [e.target.name]: e.target.value})
    }

    async function handleProceed(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        setView('pin')
    }

    async function handleSubmit() {
        setGeneratedCode('2538')
        setView('generated-code-view')
    }
    
    return (
        <>
            { view === 'generate-code' &&
                <AppCenterPopupD3 height='65' zIndex='6' overflow='hidden' close={close}>
                    <CenterPopupHeaderD3 title='Cardless Withdrawal' close={close} />
                    <CustomContainer 
                        height="65" bottomPadding='1.5'
                        style={{maxHeight: '100%'}}
                        className="popup-content-container"
                    >
                        <GridContainer 
                            height="3.6" topMargin="3" bottomMargin="2.5" 
                        >
                            <AbsoluteContainer width='50' sizeUnit="%" top="0" left={`${navPosition}`} lSizeUnit='%'>
                                <CustomContainer 
                                    bgColor="#E7F6F5" height="3.6" radius="0.6" 
                                    borderBottomColor='#0D968F' borderWidth='4.5'
                                />
                            </AbsoluteContainer>
                            <FlexRow zIndex="2">
                                <AppSpan 
                                    color={navPosition === 0 ? "#0A756F" : "#667085"}
                                    textSize="1.4" cursor="pointer" fontWeight='600'
                                    width='50' sizeUnit='%' align='center'
                                    onClick={() => setNavPosition(0)}
                                >
                                    New Code
                                </AppSpan>
                                <AppSpan 
                                    color={navPosition === 50 ? "#0A756F" : "#667085"}
                                    textSize="1.4" cursor="pointer" fontWeight='600'
                                    width='50' sizeUnit='%' align='center'
                                    onClick={() => setNavPosition(50)}
                                >
                                    Active Codes
                                </AppSpan>
                            </FlexRow>
                        </GridContainer>
                        <Form 
                            style={{height: '76%'}}
                            className='overflow-y-container'
                            onSubmit={handleProceed}
                        >
                            { navPosition === 0 &&
                                <>
                                    <GridContainer height='18.6' bottomMargin='2'>
                                        <WithdrawalIcon className='icon-component' />
                                    </GridContainer>
                                    <FormGroup>
                                        <label>Amount</label>
                                        <input 
                                            placeholder='Enter Amount' 
                                            name='amount'
                                            value={input.amount ? utility.koboFormat(input.amount) : ''}
                                            onChange={handleInput}
                                            autoComplete="off"
                                            required
                                        />
                                    </FormGroup>
                                    <FormGroupWithIcon>
                                        <label>Source Account</label>
                                        <div className="input-with-icon">
                                            <select 
                                                name='accountNumber'
                                                value={input.sourceAccount}
                                                style={{color: input.sourceAccount ? '#000000' : '#667085'}}
                                                onChange={handleInput}
                                                disabled={accountWithBalanceDetails?.length === 1}
                                                required
                                            >
                                                <option value="">Select Account</option>
                                                {
                                                    accountWithBalanceDetails?.map((item: any, index: number) => {
                                                        return (
                                                            <option 
                                                                value={item.nuban} 
                                                                key={index}
                                                                disabled={item.nuban === input.sourceAccount}
                                                            >
                                                                {item.nuban} - ({moneyFormat(item?.balance?.withdrawableAmount,institutionData?.defaultCurrency)})
                                                            </option>
                                                        )
                                                    })
                                                }
                                            </select>
                                            <FiChevronDown className="input-with-icon-tag" />
                                        </div>
                                    </FormGroupWithIcon>
                                </>
                            }
                            { navPosition === 50 &&
                                cardlessWithdrawalActiveCode?.map((item, index) => {
                                    return (
                                        <GridContainer 
                                            minHeight="7.2" bottomMargin='1' key={index}
                                            className="beneficiary-container"
                                            style={{borderBottom: '1px solid #EAECF0'}}
                                        >
                                            <FlexRow justifyContent="space-between" gap="1.5" rightPadding="1.5">
                                                <FlexRow width="auto" sizeUnit='' gap="2">
                                                    <ActiveLockIcon className='icon-component' />
                                                    <CustomContainer width="auto" sizeUnit="">
                                                        <AppSpan fontWeight="600" color="#101828" cursor="pointer">{item.code}</AppSpan>
                                                        <AppText textSize="1.1" color="#F20A0A" cursor="pointer">{item.timeLeft} left</AppText>
                                                    </CustomContainer>
                                                </FlexRow>
                                                <AppSpan color='#667085'>{item.amount}</AppSpan>
                                            </FlexRow>
                                        </GridContainer>
                                    )
                                })
                            }
                            
                            <Button 
                                width='100' sizeUnit='%' height='4.4' topMargin='1.5' 
                                borderColor='#0D968F' hoverBgColor='#fff' 
                                hoverColor='#0D968F' titleSize='1.4'
                            >
                                Generate Access Code
                            </Button>
                        </Form>
                        {/* <ComingSoon width='38' height='33' topMargin='8' /> */}
                    </CustomContainer>
                </AppCenterPopupD3>
            }
            { view === 'pin' &&
                <TxPinVerificationD3
                    close={close}
                    next={handleSubmit} 
                />
            }
            { view === 'generated-code-view' &&
                <GeneratedCodeViewD3
                    close={close}
                    code={generatedCode} 
                />
            }
        </>
    )
}